(function () {
  const config = window.theme || {};
  const strings = config.strings || {};
  const routes = config.routes || {};
  const moneyFormat = config.moneyFormat || '${{amount}}';

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    const [whole, fraction] = value.split('.');
    const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, `${withCommas}.${fraction}`)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, `${whole}.${fraction}`.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withCommas);
  }

  /* Drawers */
  const drawers = {};
  let closeMobileNav = () => {};
  let drawerReturnFocus = null;
  let openingDrawer = false;
  document.querySelectorAll('[data-drawer]').forEach((drawer) => {
    drawers[drawer.dataset.drawer] = drawer;
    drawer.querySelectorAll('[data-drawer-close]').forEach((button) => {
      button.addEventListener('click', () => closeDrawer(drawer.dataset.drawer));
    });
  });

  function drawerFocusable(drawer) {
    return [...drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
      .filter((el) => !el.closest('[hidden]'));
  }

  function openDrawer(name) {
    const drawer = drawers[name];
    if (!drawer || !drawer.hidden) return;
    openingDrawer = true;
    if (!Object.values(drawers).some((entry) => entry !== drawer && !entry.hidden)) {
      drawerReturnFocus = document.activeElement;
    }
    Object.keys(drawers).forEach((key) => {
      if (key !== name) closeDrawer(key, true);
    });
    closeMobileNav();
    window.clearTimeout(drawer.closeTimer);
    drawer.hidden = false;
    drawer.dataset.state = 'open';
    document.body.style.overflow = 'hidden';
    openingDrawer = false;
    window.requestAnimationFrame(() => {
      const close = drawer.querySelector('.drawer-panel [data-drawer-close]');
      if (close) close.focus();
    });
  }

  function closeDrawer(name, immediate) {
    const drawer = drawers[name];
    if (!drawer || drawer.hidden) return;
    drawer.dataset.state = 'closed';
    const finish = () => {
      drawer.hidden = true;
      const stillOpen = Object.values(drawers).some((entry) => !entry.hidden);
      if (!stillOpen && !openingDrawer) {
        document.body.style.overflow = '';
        const back = drawerReturnFocus;
        drawerReturnFocus = null;
        if (back && typeof back.focus === 'function') back.focus();
      }
    };
    if (immediate) {
      finish();
    } else {
      drawer.closeTimer = window.setTimeout(finish, 300);
    }
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      Object.keys(drawers).forEach((key) => closeDrawer(key));
      closeMobileNav();
      const guide = document.querySelector('[data-size-guide]');
      if (guide) guide.hidden = true;
      return;
    }
    if (event.key !== 'Tab') return;
    const open = Object.values(drawers).find((drawer) => !drawer.hidden && drawer.dataset.state === 'open');
    if (!open) return;
    const items = drawerFocusable(open);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* Cart */
  const cart = {
    items: [],
  };

  function cartCount() {
    return cart.items.reduce((total, item) => total + item.quantity, 0);
  }

  function cartSubtotal() {
    return cart.items.reduce((total, item) => total + item.priceCents * item.quantity, 0);
  }

  async function refreshCart() {
    try {
      const response = await fetch(`${routes.cart || '/cart'}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`Cart request failed with status ${response.status}`);
      const data = await response.json();
      cart.items = (data.items || []).map((item) => ({
        key: item.key,
        brand: item.vendor || '',
        name: item.product_title || item.title,
        priceCents: item.final_price,
        image: item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_240x320_crop_center$1$2') : '',
        size: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '',
        quantity: item.quantity,
      }));
    } catch (error) {
      cart.items = [];
    }
    renderCart();
  }

  async function addToCart(item, quantity = 1) {
    if (!item.variantId) return false;
    try {
      const response = await fetch(routes.cartAdd || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(item.variantId), quantity }] }),
      });
      if (!response.ok) throw new Error(`Add to cart failed with status ${response.status}`);
      await refreshCart();
      openDrawer('cart');
      return true;
    } catch (error) {
      console.error('Unable to add item to Shopify cart.', error);
      return false;
    }
  }

  async function changeQuantity(item, quantity) {
    try {
      const response = await fetch(routes.cartChange || '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity }),
      });
      if (!response.ok) throw new Error(`Cart update failed with status ${response.status}`);
    } catch (error) {
      console.error('Unable to update Shopify cart.', error);
    }
    await refreshCart();
  }

  function renderCart() {
    const drawer = drawers.cart;
    const count = cartCount();
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = count; });
    if (!drawer) return;
    drawer.querySelectorAll('[data-cart-drawer-count]').forEach((el) => { el.textContent = count; });
    const empty = drawer.querySelector('[data-cart-empty]');
    const wrapper = drawer.querySelector('[data-cart-items-wrapper]');
    const footer = drawer.querySelector('[data-cart-footer]');
    const list = drawer.querySelector('[data-cart-items]');
    const template = drawer.querySelector('[data-cart-item-template]');
    empty.hidden = cart.items.length > 0;
    wrapper.hidden = cart.items.length === 0;
    footer.hidden = cart.items.length === 0;
    list.innerHTML = '';
    cart.items.forEach((item) => {
      const node = template.content.firstElementChild.cloneNode(true);
      const image = node.querySelector('[data-item-image]');
      image.src = item.image;
      image.alt = `${item.brand} ${item.name}`;
      node.querySelector('[data-item-brand]').textContent = item.brand;
      node.querySelector('[data-item-name]').textContent = item.name;
      const size = node.querySelector('[data-item-size]');
      if (item.size) {
        size.textContent = `${strings.size || 'Size'} ${item.size}`;
        size.hidden = false;
      }
      node.querySelector('[data-item-price]').textContent = formatMoney(item.priceCents);
      node.querySelector('[data-item-quantity]').textContent = item.quantity;
      node.querySelector('[data-item-decrease]').addEventListener('click', () => changeQuantity(item, item.quantity - 1));
      node.querySelector('[data-item-increase]').addEventListener('click', () => changeQuantity(item, item.quantity + 1));
      node.querySelector('[data-item-remove]').addEventListener('click', () => changeQuantity(item, 0));
      list.appendChild(node);
    });
    drawer.querySelector('[data-cart-subtotal]').textContent = formatMoney(cartSubtotal());
  }

  function productFromCard(card) {
    return {
      handle: card.dataset.handle,
      brand: card.dataset.brand,
      name: card.dataset.title,
      price: card.dataset.price,
      image: card.dataset.image,
      url: card.dataset.url,
      variantId: card.dataset.variantId || '',
    };
  }

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('[data-add-to-bag]');
    if (addButton) {
      event.preventDefault();
      if (addButton.disabled) return;
      addToCart(productFromCard(addButton.closest('[data-product-card]')));
    }
  });

  document.querySelectorAll('[data-cart-open]').forEach((button) => {
    button.addEventListener('click', () => openDrawer('cart'));
  });

  /* Favorites, saved in this browser */
  const FAVORITES_KEY = 'euromoda-favorites';

  function loadFavorites() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(FAVORITES_KEY) || '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed.filter((item) => item && item.handle);
    } catch (error) {
      return [];
    }
  }

  let favorites = loadFavorites();

  function saveFavorites() {
    try {
      window.localStorage.setItem(FAVORITES_KEY, JSON.stringify(favorites));
    } catch (error) {
      console.error('Unable to save favorites.', error);
    }
  }

  function favoriteSource(button) {
    const card = button.closest('[data-product-card]');
    if (card) {
      const product = productFromCard(card);
      return {
        handle: product.handle,
        brand: product.brand,
        name: product.name,
        price: product.price,
        image: product.image,
        url: product.url,
      };
    }
    const product = button.closest('[data-product]');
    if (!product) return null;
    const priceNode = product.querySelector('[data-product-price]');
    return {
      handle: product.dataset.productHandle,
      brand: product.dataset.productBrand,
      name: product.dataset.productTitle,
      price: priceNode ? priceNode.textContent.trim() : '',
      image: product.dataset.productImage,
      url: product.dataset.productUrl,
    };
  }

  function syncFavoriteButtons() {
    const handles = new Set(favorites.map((item) => item.handle));
    document.querySelectorAll('[data-favorite]').forEach((button) => {
      const source = button.closest('[data-product-card], [data-product]');
      const handle = source ? (source.dataset.handle || source.dataset.productHandle) : '';
      const saved = handles.has(handle);
      button.setAttribute('aria-pressed', String(saved));
      const labelText = saved ? (strings.favoriteSaved || 'Saved to favorites') : (strings.favoriteSave || 'Save to favorites');
      button.setAttribute('aria-label', labelText);
      const label = button.querySelector('[data-favorite-label]');
      if (label) label.textContent = labelText;
    });
    document.querySelectorAll('[data-favorites-count], [data-favorites-drawer-count]').forEach((el) => {
      el.textContent = favorites.length;
    });
    document.querySelectorAll('[data-favorites-count]').forEach((el) => {
      el.hidden = favorites.length === 0;
    });
  }

  function renderFavorites() {
    const drawer = drawers.favorites;
    syncFavoriteButtons();
    if (!drawer) return;
    const empty = drawer.querySelector('[data-favorites-empty]');
    const wrapper = drawer.querySelector('[data-favorites-items-wrapper]');
    const list = drawer.querySelector('[data-favorites-items]');
    const template = drawer.querySelector('[data-favorites-item-template]');
    empty.hidden = favorites.length > 0;
    wrapper.hidden = favorites.length === 0;
    list.innerHTML = '';
    favorites.forEach((item) => {
      const node = template.content.firstElementChild.cloneNode(true);
      const image = node.querySelector('[data-item-image]');
      image.src = item.image || '';
      image.alt = `${item.brand || ''} ${item.name || ''}`.trim();
      node.querySelectorAll('[data-item-link], [data-item-title-link]').forEach((link) => {
        link.href = item.url || '#';
      });
      node.querySelector('[data-item-brand]').textContent = item.brand || '';
      node.querySelector('[data-item-name]').textContent = item.name || '';
      node.querySelector('[data-item-price]').textContent = item.price || '';
      node.querySelector('[data-favorite-remove]').addEventListener('click', () => {
        favorites = favorites.filter((entry) => entry.handle !== item.handle);
        saveFavorites();
        renderFavorites();
      });
      list.appendChild(node);
    });
  }

  function toggleFavorite(item) {
    if (!item || !item.handle) return;
    const existing = favorites.some((entry) => entry.handle === item.handle);
    favorites = existing
      ? favorites.filter((entry) => entry.handle !== item.handle)
      : [item, ...favorites];
    saveFavorites();
    renderFavorites();
  }

  document.addEventListener('click', (event) => {
    const favoriteButton = event.target.closest('[data-favorite]');
    if (!favoriteButton) return;
    event.preventDefault();
    event.stopPropagation();
    toggleFavorite(favoriteSource(favoriteButton));
  });

  document.querySelectorAll('[data-favorites-open]').forEach((button) => {
    button.addEventListener('click', () => {
      renderFavorites();
      openDrawer('favorites');
    });
  });

  renderFavorites();

  /* Header mega menu and mobile nav */
  const header = document.querySelector('[data-header]');
  if (header) {
    const panels = header.querySelector('[data-menu-panels]');
    const triggers = header.querySelectorAll('[data-menu-trigger]');
    const navToggle = header.querySelector('[data-nav-toggle]');
    const mobileNav = header.querySelector('[data-mobile-nav]');
    const whatsapp = header.querySelector('[data-whatsapp]');
    const whatsappToggle = header.querySelector('[data-whatsapp-toggle]');
    const whatsappMenu = header.querySelector('[data-whatsapp-menu]');
    const setWhatsapp = (open) => {
      if (!whatsappMenu || !whatsappToggle) return;
      whatsappMenu.hidden = !open;
      whatsappToggle.setAttribute('aria-expanded', String(open));
    };
    const setOpen = (id) => {
      if (id) setWhatsapp(false);
      triggers.forEach((trigger) => {
        if (trigger.dataset.menuTrigger === id) {
          trigger.setAttribute('data-open', '');
        } else {
          trigger.removeAttribute('data-open');
        }
      });
      let any = false;
      header.querySelectorAll('[data-menu-panel]').forEach((panel) => {
        const match = panel.dataset.menuPanel === id;
        panel.hidden = !match;
        if (match) any = true;
      });
      if (panels) panels.hidden = !any;
    };
    const setMobileNav = (open) => {
      if (!mobileNav || !navToggle) return;
      mobileNav.hidden = !open;
      navToggle.setAttribute('aria-expanded', String(open));
      navToggle.setAttribute('aria-label', open ? (strings.closeMenu || 'Close menu') : (strings.menu || 'Open menu'));
      const openIcon = navToggle.querySelector('[data-nav-icon="open"]');
      const closeIcon = navToggle.querySelector('[data-nav-icon="close"]');
      if (openIcon) openIcon.hidden = open;
      if (closeIcon) closeIcon.hidden = !open;
      if (open) {
        header.setAttribute('data-nav-open', '');
        setOpen(null);
        setWhatsapp(false);
        document.body.style.overflow = 'hidden';
      } else {
        header.removeAttribute('data-nav-open');
        if (!Object.values(drawers).some((entry) => !entry.hidden)) {
          document.body.style.overflow = '';
        }
      }
    };
    closeMobileNav = () => setMobileNav(false);
    if (navToggle && mobileNav) {
      navToggle.addEventListener('click', () => setMobileNav(mobileNav.hidden));
      mobileNav.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.stopPropagation();
          closeMobileNav();
        });
      });
      const desktopQuery = window.matchMedia('(min-width: 1024px)');
      const onDesktopChange = (event) => {
        if (event.matches) closeMobileNav();
      };
      if (desktopQuery.addEventListener) {
        desktopQuery.addEventListener('change', onDesktopChange);
      } else {
        desktopQuery.addListener(onDesktopChange);
      }
    }
    triggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => setOpen(trigger.dataset.menuTrigger));
      trigger.addEventListener('focus', () => setOpen(trigger.dataset.menuTrigger));
    });
    header.querySelectorAll('[data-menu-close]').forEach((link) => {
      link.addEventListener('mouseenter', () => setOpen(null));
      link.addEventListener('focus', () => setOpen(null));
    });
    header.querySelectorAll('nav a:not([data-menu-trigger])').forEach((link) => {
      link.addEventListener('mouseenter', () => setOpen(null));
    });
    header.addEventListener('mouseleave', () => setOpen(null));
    if (whatsapp && whatsappToggle && whatsappMenu) {
      whatsappToggle.addEventListener('click', (event) => {
        event.stopPropagation();
        const open = whatsappMenu.hidden;
        setOpen(null);
        setWhatsapp(open);
      });
      whatsappMenu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => setWhatsapp(false));
      });
      document.addEventListener('click', (event) => {
        if (!whatsapp.contains(event.target)) setWhatsapp(false);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') setWhatsapp(false);
      });
    }
  }

  /* Hero slideshow */
  const hero = document.querySelector('[data-hero]');
  if (hero) {
    const slides = hero.querySelectorAll('[data-hero-slide]');
    const dots = hero.querySelectorAll('[data-hero-dot]');
    let index = 0;
    let timer;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const arm = () => {
      window.clearInterval(timer);
      if (reduceMotion || slides.length < 2 || document.hidden) return;
      timer = window.setInterval(() => show(index + 1), 4500);
    };
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('opacity-100', active);
        slide.classList.toggle('opacity-0', !active);
        slide.toggleAttribute('aria-hidden', !active);
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('bg-background', i === index);
        dot.classList.toggle('bg-background/40', i !== index);
      });
      arm();
    };
    document.addEventListener('visibilitychange', arm);
    const next = hero.querySelector('[data-hero-next]');
    if (next) next.addEventListener('click', () => show(index + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.heroDot))));
    show(0);
  }

  /* Collection filters */
  document.querySelectorAll('[data-filter-form]').forEach((form) => {
    form.querySelectorAll('[data-filter-input]').forEach((input) => {
      input.addEventListener('change', () => form.submit());
    });
    const dropdowns = form.querySelectorAll('[data-filter-dropdown]');
    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener('toggle', () => {
        if (!dropdown.open) return;
        dropdowns.forEach((other) => {
          if (other !== dropdown) other.open = false;
        });
      });
    });
    document.addEventListener('click', (event) => {
      if (form.contains(event.target)) return;
      dropdowns.forEach((dropdown) => {
        dropdown.open = false;
      });
    });
  });

  document.querySelectorAll('[data-chip-filter]').forEach((chip) => {
    chip.addEventListener('click', () => {
      const row = chip.parentElement;
      const value = chip.dataset.chipFilter;
      const field = chip.dataset.chipField;
      row.querySelectorAll('[data-chip-filter]').forEach((other) => {
        other.setAttribute('aria-pressed', String(other === chip));
      });
      document.querySelectorAll('[data-product-card]').forEach((card) => {
        card.hidden = Boolean(value) && (card.dataset[field] || '').toLowerCase() !== value.toLowerCase();
      });
    });
  });

  /* Made to Measure: landing and brand views are addressed by the URL hash */
  const mtm = document.querySelector('[data-mtm]');
  if (mtm) {
    const views = mtm.querySelectorAll('[data-mtm-view]');
    const appointment = mtm.querySelector('[data-mtm-appointment]');
    let currentView = views[0];

    const showView = () => {
      const hash = decodeURIComponent(window.location.hash.slice(1));
      if (hash === 'mtm-appointment') return;
      const target = [...views].find((view) => view.dataset.mtmView === hash) || views[0];
      views.forEach((view) => {
        view.hidden = view !== target;
      });
      const back = document.querySelector('[data-back-link]');
      if (back) back.parentElement.hidden = target.dataset.mtmView !== 'home' || back.dataset.backVisible !== 'true';
      if (target !== currentView) window.scrollTo(0, 0);
      currentView = target;
    };

    mtm.querySelectorAll('a[href="#mtm-appointment"]').forEach((link) => {
      link.addEventListener('click', () => {
        if (appointment) window.requestAnimationFrame(() => appointment.focus({ preventScroll: true }));
      });
    });

    const dateInput = appointment && appointment.querySelector('[data-book-date]');
    if (dateInput) dateInput.min = new Date().toISOString().slice(0, 10);
    window.addEventListener('hashchange', showView);
    showView();
    const formStatus = mtm.querySelector('[data-mtm-posted], [data-mtm-errors]');
    if (formStatus) {
      appointment.scrollIntoView();
      formStatus.focus({ preventScroll: true });
    }
  }

  /* Journal: category filter, search, featured first story and story previews */
  const journal = document.querySelector('[data-journal]');
  if (journal) {
    const items = [...journal.querySelectorAll('[data-journal-item]')];
    const buttons = [...journal.querySelectorAll('[data-journal-category]')];
    const search = journal.querySelector('[data-journal-search]');
    const count = journal.querySelector('[data-journal-count]');
    const empty = journal.querySelector('[data-journal-empty]');
    const requested = new URLSearchParams(window.location.search).get('category');
    const match = buttons.find((button) => button.dataset.journalCategory.toLowerCase() === (requested || '').toLowerCase());
    const latest = buttons[0] ? buttons[0].dataset.journalCategory : '';
    let category = match ? match.dataset.journalCategory : latest;
    const draw = () => {
      const query = search ? search.value.trim().toLowerCase() : '';
      let visible = 0;
      items.forEach((item) => {
        const show = (!category || category === latest || item.dataset.category === category) && (!query || (item.dataset.search || '').includes(query));
        item.hidden = !show;
        item.toggleAttribute('data-featured', show && visible === 0);
        if (show) visible += 1;
      });
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.journalCategory === category)));
      if (empty) empty.classList.toggle('hidden', visible > 0);
      if (count) {
        const label = visible === 1 ? count.dataset.storyOne : (count.dataset.storyOther || '').replace('{{ count }}', visible);
        count.textContent = category ? `${label} · ${category}` : label;
      }
    };
    buttons.forEach((button) => button.addEventListener('click', () => {
      category = button.dataset.journalCategory;
      draw();
    }));
    if (search) search.addEventListener('input', draw);
    draw();

    const modal = journal.querySelector('[data-journal-modal]');
    const setModal = (open) => {
      modal.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
    };
    journal.querySelectorAll('[data-journal-story]').forEach((story) => {
      story.addEventListener('click', () => {
        modal.querySelector('[data-journal-modal-media]').textContent = story.dataset.storyTitle;
        modal.querySelector('[data-journal-modal-eyebrow]').textContent = `${story.dataset.storyCategory} / The Journal`;
        modal.querySelector('[data-journal-modal-title]').textContent = story.dataset.storyTitle;
        modal.querySelector('[data-journal-modal-excerpt]').textContent = story.dataset.storyExcerpt;
        modal.querySelector('[data-journal-modal-body]').textContent = story.dataset.storyBody;
        setModal(true);
      });
    });
    if (modal) {
      modal.addEventListener('click', (event) => {
        if (event.target === modal || event.target.closest('[data-journal-close]')) setModal(false);
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal.hidden) setModal(false);
      });
    }
  }

  /* Edit coming soon: show the Edit named in ?edit= */
  const editSoon = document.querySelector('[data-edit-soon]');
  if (editSoon) {
    const wanted = new URLSearchParams(window.location.search).get('edit');
    const items = editSoon.querySelectorAll('[data-edit-soon-item]');
    const match = [...items].find((item) => item.dataset.editSoonItem === wanted) || items[0];
    items.forEach((item) => {
      item.hidden = item !== match;
    });
    const heading = match && match.querySelector('h1');
    if (heading) document.title = document.title.replace(/^[^|]+/, `${heading.textContent.trim()} `);
  }

  /* Product page */
  const product = document.querySelector('[data-product]');
  if (product) {
    const variantsNode = product.querySelector('[data-product-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const sizePosition = product.dataset.sizePosition;
    const sizeButtons = product.querySelectorAll('[data-size-option]');
    const sizeError = product.querySelector('[data-size-error]');
    const priceNode = product.querySelector('[data-product-price]');
    let selectedSize = null;

    const findVariant = () => {
      if (!sizePosition) return variants.find((variant) => variant.available) || variants[0];
      return variants.find((variant) => variant[sizePosition] === selectedSize && variant.available)
        || variants.find((variant) => variant[sizePosition] === selectedSize);
    };

    sizeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        selectedSize = button.dataset.sizeOption;
        sizeButtons.forEach((other) => {
          if (other === button) other.setAttribute('data-active', '');
          else other.removeAttribute('data-active');
        });
        if (sizeError) sizeError.hidden = true;
        const variant = findVariant();
        if (variant && priceNode) priceNode.textContent = variant.price;
        syncAddButton();
      });
    });

    const productData = () => {
      const variant = findVariant();
      return {
        handle: product.dataset.productHandle,
        brand: product.dataset.productBrand,
        name: product.dataset.productTitle,
        price: variant ? variant.price : priceNode ? priceNode.textContent : '',
        image: product.dataset.productImage,
        url: product.dataset.productUrl,
        variantId: variant ? variant.id : '',
        size: selectedSize || '',
      };
    };

    const addButton = product.querySelector('[data-product-add]');
    const labelAdd = addButton ? (addButton.getAttribute('data-label-add') || strings.addToBag || 'Add to bag') : '';
    const labelSoldOut = addButton ? (addButton.getAttribute('data-label-sold-out') || strings.soldOut || 'Sold Out') : '';
    const anyAvailable = variants.some((variant) => variant.available);

    const syncAddButton = () => {
      if (!addButton) return;
      let unavailable = !anyAvailable;
      if (!unavailable && sizePosition && selectedSize) {
        const variant = findVariant();
        unavailable = !variant || !variant.available;
      }
      if (!unavailable && !sizePosition) {
        const variant = findVariant();
        unavailable = !variant || !variant.available;
      }
      addButton.disabled = unavailable;
      addButton.textContent = unavailable ? labelSoldOut : labelAdd;
    };

    if (addButton) {
      addButton.addEventListener('click', () => {
        if (addButton.disabled) return;
        if (sizeButtons.length && !selectedSize) {
          if (sizeError) sizeError.hidden = false;
          return;
        }
        const variant = findVariant();
        if (!variant || !variant.available) {
          syncAddButton();
          return;
        }
        addToCart(productData());
      });
    }
    syncAddButton();

    const guide = document.querySelector('[data-size-guide]');
    if (guide) {
      product.querySelectorAll('[data-size-guide-open]').forEach((button) => {
        button.addEventListener('click', () => { guide.hidden = false; });
      });
      guide.querySelectorAll('[data-size-guide-close]').forEach((button) => {
        button.addEventListener('click', () => { guide.hidden = true; });
      });
    }
  }

  const shopRoot = () => (routes.root && routes.root !== '/' ? routes.root.replace(/\/$/, '') : '');
  const normalize = (value) => String(value || '').trim().toLowerCase();

  const catalogRequests = new Map();
  function fetchCatalog(handle = 'all') {
    if (!catalogRequests.has(handle)) {
      catalogRequests.set(handle, loadCatalog(handle).catch((error) => {
        catalogRequests.delete(handle);
        throw error;
      }));
    }
    return catalogRequests.get(handle);
  }

  async function loadCatalog(handle) {
    const products = [];
    for (let page = 1; page <= 10; page += 1) {
      const response = await fetch(`${shopRoot()}/collections/${handle}/products.json?limit=250&page=${page}`);
      if (!response.ok) break;
      const data = await response.json();
      const batch = data.products || [];
      products.push(...batch);
      if (batch.length < 250) break;
    }
    return products;
  }

  function catalogPrice(product) {
    const variant = (product.variants || [])[0];
    if (!variant || variant.price == null || variant.price === '') return '';
    const cents = Math.round(parseFloat(variant.price) * 100);
    if (Number.isNaN(cents)) return String(variant.price);
    return formatMoney(cents);
  }

  function catalogTags(product) {
    return (Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',')).map((tag) => tag.trim().toLowerCase());
  }

  function catalogOnSale(product) {
    return catalogTags(product).includes('sale');
  }

  function catalogPhoto(product) {
    return product.images && product.images[0];
  }

  function catalogImage(product) {
    const image = catalogPhoto(product);
    if (!image || !image.src) return '';
    return `${image.src}${image.src.includes('?') ? '&' : '?'}width=1200`;
  }

  let bestSellingOrder;
  async function fetchBestSellingOrder() {
    if (bestSellingOrder) return bestSellingOrder;
    const order = new Map();
    for (let page = 1; page <= 10; page += 1) {
      const response = await fetch(`${shopRoot()}/collections/all?view=sort-order&sort_by=best-selling&page=${page}`);
      if (!response.ok) break;
      const handles = JSON.parse(await response.text());
      handles.forEach((handle) => {
        if (!order.has(handle)) order.set(handle, order.size);
      });
      if (handles.length < 250) break;
    }
    bestSellingOrder = order;
    return order;
  }

  function productPrice(product) {
    const variant = (product.variants || [])[0];
    const price = variant ? parseFloat(variant.price) : NaN;
    return Number.isNaN(price) ? 0 : price;
  }

  function productCreatedAt(product) {
    const stamp = Date.parse(product.created_at || product.published_at || '');
    return Number.isNaN(stamp) ? 0 : stamp;
  }

  async function sortShopProducts(products, sort) {
    const sorted = [...products];
    const byTitle = (a, b) => (a.title || '').localeCompare(b.title || '');
    if (sort === 'price-ascending') return sorted.sort((a, b) => productPrice(a) - productPrice(b) || byTitle(a, b));
    if (sort === 'price-descending') return sorted.sort((a, b) => productPrice(b) - productPrice(a) || byTitle(a, b));
    if (sort === 'created-descending') return sorted.sort((a, b) => productCreatedAt(b) - productCreatedAt(a) || byTitle(a, b));
    let order;
    try {
      order = await fetchBestSellingOrder();
    } catch (error) {
      order = new Map();
    }
    const rank = (product) => (order.has(product.handle) ? order.get(product.handle) : Number.MAX_SAFE_INTEGER);
    return sorted.sort((a, b) => rank(a) - rank(b) || byTitle(a, b));
  }

  /* Shoes and Accessories match the product Type field. Clothing menu items match product tags. */
  function groupMatcher(config, group) {
    const set = (list) => new Set((list || []).map(normalize).filter(Boolean));
    const shoes = set(config.shoes);
    const accessories = set(config.accessories);
    const excluded = set(config.excluded);
    const labels = config.labels || {};
    const groups = config.groups || [];
    const typeOf = (product) => normalize(product.product_type);
    const listed = (product) => !excluded.has(typeOf(product));
    const hasTag = (product, tags) => {
      const productTags = new Set(catalogTags(product));
      return tags.some((tag) => productTags.has(tag));
    };
    if (group === 'shoes') return { label: labels.shoes, test: (product) => shoes.has(typeOf(product)) };
    if (group === 'accessories') return { label: labels.accessories, test: (product) => accessories.has(typeOf(product)) };
    if (group === 'sale') return { label: 'Sale', test: (product) => catalogTags(product).includes('sale') };
    if (group === 'sport') {
      return {
        label: labels.sport || 'Euromoda Sport',
        test: (product) => catalogTags(product).includes('euromoda sport'),
      };
    }
    const clothingTypes = new Set(groups.map((entry) => normalize(entry.name)).filter(Boolean));
    const clothingTags = [...new Set(groups.flatMap((entry) => (entry.tags || []).map(normalize)).filter(Boolean))];
    const isClothing = (product) => listed(product) && (clothingTypes.has(typeOf(product)) || hasTag(product, clothingTags));
    if (group === 'clothing') {
      return {
        label: labels.clothing,
        test: isClothing,
      };
    }
    if (group === 'menswear') {
      return {
        label: labels.menswear || labels.shop_all || 'Shop All',
        test: (product) => isClothing(product) || shoes.has(typeOf(product)) || accessories.has(typeOf(product)),
      };
    }
    const custom = groups.find((entry) => entry.handle === group);
    if (custom) {
      const tags = [...set(custom.tags)];
      return {
        label: custom.name,
        parent: labels.clothing,
        sleeve: Boolean(custom.sleeve),
        test: (product) => hasTag(product, tags),
      };
    }
    return { label: '', test: listed };
  }

  const SIZE_ORDER = ['xxs', 'xs', 'x-small', 'small', 's', 'medium', 'm', 'large', 'l', 'x-large', 'xl', 'xx-large', 'xxl', '2xl', 'xxx-large', 'xxxl', '3xl', 'o/s', 'os', 'one size'];
  function sizeRank(value) {
    const index = SIZE_ORDER.indexOf(normalize(value));
    if (index !== -1) return index;
    const number = parseFloat(value);
    return Number.isNaN(number) ? 1000 : 100 + number;
  }

  function optionValues(product, names) {
    const option = (product.options || []).find((entry) => names.includes(normalize(entry.name)));
    return option ? option.values || [] : [];
  }

  function productFacets(product, config) {
    const tags = (Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',')).map(normalize);
    const colours = new Set();
    const colourList = (config.colours || []).filter(Boolean);
    const matchColour = (value) => colourList.find((colour) => normalize(value).split(/[\s/-]+/).includes(normalize(colour)));
    optionValues(product, ['color', 'colour']).forEach((value) => colours.add(matchColour(value) || value));
    tags.forEach((tag) => {
      const match = matchColour(tag.replace(/^cf-colou?r-/, ''));
      if (match) colours.add(match);
    });
    const fabrics = (config.fabrics || []).filter((fabric) => fabric && tags.includes(normalize(fabric)));
    const sleeve = sleeveLengths(tags);
    return {
      category: product.product_type ? [product.product_type.trim()] : [],
      brand: product.vendor ? [product.vendor] : [],
      colour: [...colours],
      size: optionValues(product, ['size']),
      fabric: fabrics,
      sleeve,
    };
  }

  const FILTER_KEYS = ['brand', 'colour', 'size', 'sleeve', 'fabric'];
  const FILTER_LABELS = { brand: 'Brand', colour: 'Color', size: 'Size', fabric: 'Fabric', sleeve: 'Sleeve length' };

  function sleeveLengths(tags) {
    const lengths = [];
    const tagged = (name) => tags.some((tag) => tag === name || tag.startsWith(`${name} `));
    if (tagged('short sleeve')) lengths.push('Short Sleeve');
    if (tagged('long sleeve')) lengths.push('Long Sleeve');
    return lengths;
  }

  function isSleeveCategory(value) {
    const name = normalize(value);
    return name === 'short sleeve' || name === 'long sleeve' || name.startsWith('short sleeve ') || name.startsWith('long sleeve ');
  }

  async function renderShopGroup(section) {
    const grid = section.querySelector('[data-shop-grid]');
    if (!grid || !section.querySelector('[data-shop-card-template]')) return;
    const configNode = section.querySelector('[data-product-groups]');
    let config = {};
    try {
      config = configNode ? JSON.parse(configNode.textContent) : {};
    } catch (error) {
      config = {};
    }
    const params = new URLSearchParams(window.location.search);
    const group = section.dataset.shopGroup === 'url' ? normalize(params.get('group')) : normalize(section.dataset.shopGroup);
    const matcher = groupMatcher(config, group);

    const heading = section.querySelector('[data-shop-heading]');
    const eyebrow = section.querySelector('[data-shop-eyebrow]');
    if (matcher.label && heading) {
      heading.textContent = matcher.label;
      document.title = document.title.replace(/^[^|]+/, `${matcher.label} `);
      if (eyebrow) {
        if (!eyebrow.textContent.trim() && matcher.parent) eyebrow.textContent = matcher.parent;
        eyebrow.classList.toggle('hidden', !eyebrow.textContent.trim());
      }
    }

    const newSource = section.dataset.shopNewSource;
    const newHandlesRequest = newSource
      ? fetchCatalog(newSource).then((items) => new Set(items.map((item) => item.handle))).catch(() => new Set())
      : Promise.resolve(new Set());
    const bestCap = section.dataset.shopBestSellers === 'true' ? 96 : 0;
    const pageSize = bestCap > 0 ? 24 : 0;
    let products = [];
    try {
      products = (await fetchCatalog(section.dataset.shopSource || 'all')).filter(matcher.test);
    } catch (error) {
      products = [];
    }
    if (bestCap > 0) {
      const order = await fetchBestSellingOrder().catch(() => new Map());
      if (order.size > 0) {
        products = (await sortShopProducts(products, 'best-selling')).slice(0, bestCap);
      }
    }
    const newHandles = await newHandlesRequest;
    const facets = new Map(products.map((product) => [product.handle, productFacets(product, config)]));
    const groups = config.groups || [];
    if (group === 'clothing' || group === 'menswear') {
      const shoeTypes = new Set((config.shoes || []).map(normalize).filter(Boolean));
      const accessoryTypes = new Set((config.accessories || []).map(normalize).filter(Boolean));
      products.forEach((product) => {
        const names = groups.filter((entry) => {
          const tags = (entry.tags || []).map(normalize);
          return catalogTags(product).some((tag) => tags.includes(tag)) || normalize(product.product_type) === normalize(entry.name);
        }).map((entry) => entry.name);
        if (names.length) {
          facets.get(product.handle).category = names;
        } else if (group === 'menswear') {
          const type = normalize(product.product_type);
          if (shoeTypes.has(type)) facets.get(product.handle).category = [config.labels?.shoes || 'Shoes'];
          else if (accessoryTypes.has(type)) facets.get(product.handle).category = [config.labels?.accessories || 'Accessories'];
        }
      });
    } else if (groups.some((entry) => entry.handle === group)) {
      products.forEach((product) => {
        facets.get(product.handle).category = [];
      });
    }
    const filterKeys = FILTER_KEYS;
    facets.forEach((facet) => {
      const hadCategory = facet.category.length > 0;
      const categories = facet.category.filter((value) => !isSleeveCategory(value));
      if (categories.length) facet.category = categories;
      else if (hadCategory && facet.sleeve.length) facet.category = ['Shirts'];
      else facet.category = [];
    });
    const categoryLabels = new Map();
    facets.forEach((facet) => {
      facet.category = facet.category.map((value) => {
        if (!categoryLabels.has(normalize(value))) categoryLabels.set(normalize(value), value);
        return categoryLabels.get(normalize(value));
      });
    });
    const state = { category: new Set(), brand: new Set(), colour: new Set(), size: new Set(), fabric: new Set(), sleeve: new Set() };
    ['category', ...filterKeys].forEach((key) => {
      params.getAll(key).forEach((value) => state[key].add(value));
    });

    const isShirt = (product) => group === 'shirts' || facets.get(product.handle).category.some((value) => normalize(value) === 'shirts');
    const matches = (product, skip) => Object.keys(state).every((key) => {
      if (key === skip || state[key].size === 0) return true;
      if (key === 'sleeve' && !isShirt(product)) return true;
      return facets.get(product.handle)[key].some((value) => state[key].has(value));
    });

    const sortSelect = section.querySelector('[data-sort-select="shop"]');
    const filtersEnabled = section.dataset.shopFiltersEnabled === 'true';

    const syncUrl = () => {
      const url = new URL(window.location.href);
      ['category', ...filterKeys].forEach((key) => {
        url.searchParams.delete(key);
        state[key].forEach((value) => url.searchParams.append(key, value));
      });
      window.history.replaceState({}, '', url);
    };

    const toggle = (key, value) => {
      if (state[key].has(value)) {
        state[key].delete(value);
      } else {
        state[key].add(value);
      }
      syncUrl();
      draw();
    };

    const countValues = (key) => {
      const counts = new Map();
      products.filter((product) => matches(product, key)).forEach((product) => {
        facets.get(product.handle)[key].forEach((value) => counts.set(value, (counts.get(value) || 0) + 1));
      });
      state[key].forEach((value) => {
        if (!counts.has(value)) counts.set(value, 0);
      });
      const entries = [...counts.entries()];
      if (key === 'size') return entries.sort((a, b) => sizeRank(a[0]) - sizeRank(b[0]) || a[0].localeCompare(b[0]));
      return entries.sort((a, b) => a[0].localeCompare(b[0]));
    };

    const drawFilters = () => {
      if (!filtersEnabled) return;
      const chipRow = section.querySelector('[data-shop-chips]');
      const chipTemplate = section.querySelector('[data-shop-chip-template]');
      const categories = countValues('category');
      chipRow.querySelectorAll('button').forEach((button) => button.remove());
      const showChips = categories.length > 1 || state.category.size > 0;
      chipRow.classList.toggle('hidden', !showChips);
      chipRow.classList.toggle('flex', showChips);
      if (showChips) {
        const all = chipTemplate.content.firstElementChild.cloneNode(true);
        all.textContent = 'All';
        all.setAttribute('aria-pressed', String(state.category.size === 0));
        all.addEventListener('click', () => {
          state.category.clear();
          syncUrl();
          draw();
        });
        chipRow.appendChild(all);
        categories.forEach(([value]) => {
          const chip = chipTemplate.content.firstElementChild.cloneNode(true);
          chip.textContent = value;
          chip.setAttribute('aria-pressed', String(state.category.has(value)));
          chip.addEventListener('click', () => toggle('category', value));
          chipRow.appendChild(chip);
        });
      }

      const wrapper = section.querySelector('[data-shop-filters]');
      const bar = section.querySelector('[data-shop-filter-bar]');
      const openKey = bar.querySelector('details[open]')?.dataset.filterKey;
      bar.querySelectorAll('details').forEach((node) => node.remove());
      const dropdownTemplate = section.querySelector('[data-shop-dropdown-template]');
      const optionTemplate = section.querySelector('[data-shop-option-template]');
      const shirtsSelected = group === 'shirts' || [...state.category].some((value) => normalize(value) === 'shirts');
      if (!shirtsSelected && state.sleeve.size) {
        state.sleeve.clear();
        syncUrl();
      }
      let shown = 0;
      filterKeys.forEach((key) => {
        if (key === 'sleeve' && !shirtsSelected) return;
        const values = countValues(key);
        if (values.length === 0) return;
        shown += 1;
        const dropdown = dropdownTemplate.content.firstElementChild.cloneNode(true);
        dropdown.dataset.filterKey = key;
        dropdown.open = openKey === key;
        const summary = dropdown.querySelector('summary');
        if (state[key].size) summary.setAttribute('data-active', '');
        dropdown.querySelector('[data-dropdown-label]').textContent = state[key].size ? `${FILTER_LABELS[key]} (${state[key].size})` : FILTER_LABELS[key];
        const list = dropdown.querySelector('[data-dropdown-options]');
        values.forEach(([value, count]) => {
          const option = optionTemplate.content.firstElementChild.cloneNode(true);
          const input = option.querySelector('input');
          input.checked = state[key].has(value);
          input.disabled = count === 0 && !input.checked;
          if (input.disabled) option.classList.add('opacity-40');
          input.addEventListener('change', () => toggle(key, value));
          option.querySelector('[data-option-label]').textContent = value;
          option.querySelector('[data-option-count]').textContent = String(count);
          list.appendChild(option);
        });
        dropdown.addEventListener('toggle', () => {
          if (!dropdown.open) return;
          bar.querySelectorAll('details').forEach((other) => {
            if (other !== dropdown) other.open = false;
          });
        });
        bar.appendChild(dropdown);
      });
      wrapper.classList.toggle('hidden', shown === 0);

      const active = section.querySelector('[data-shop-active]');
      const activeTemplate = section.querySelector('[data-shop-active-template]');
      active.innerHTML = '';
      filterKeys.forEach((key) => {
        state[key].forEach((value) => {
          const pill = activeTemplate.content.firstElementChild.cloneNode(true);
          pill.querySelector('[data-active-label]').textContent = `${FILTER_LABELS[key]}: ${value}`;
          pill.addEventListener('click', () => toggle(key, value));
          active.appendChild(pill);
        });
      });
      const hasActive = active.children.length > 0;
      if (hasActive) {
        const clear = document.createElement('button');
        clear.type = 'button';
        clear.className = 'text-[11px] uppercase tracking-[0.16em] text-muted-foreground underline underline-offset-4 hover:text-foreground';
        clear.textContent = 'Clear all';
        clear.addEventListener('click', () => {
          filterKeys.forEach((key) => state[key].clear());
          syncUrl();
          draw();
        });
        active.appendChild(clear);
      }
      active.classList.toggle('hidden', !hasActive);
      active.classList.toggle('flex', hasActive);
    };

    const draw = async () => {
      drawFilters();
      const visible = products.filter((product) => matches(product));
      const sorted = await sortShopProducts(visible, sortSelect ? sortSelect.value : '');
      const pager = section.querySelector('[data-shop-pages]');
      let pageItems = sorted;
      if (pager && pageSize > 0 && sorted.length > pageSize) {
        const pages = Math.ceil(sorted.length / pageSize);
        const params = new URLSearchParams(window.location.search);
        let page = Number(params.get('page')) || 1;
        if (page > pages) page = pages;
        if (page < 1) page = 1;
        pageItems = sorted.slice((page - 1) * pageSize, page * pageSize);
        pager.classList.remove('hidden');
        pager.classList.add('flex');
        pager.replaceChildren();
        for (let index = 1; index <= pages; index += 1) {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = String(index);
          button.className = index === page
            ? 'border border-foreground bg-foreground px-3 py-2 text-background'
            : 'border border-foreground/25 px-3 py-2 hover:border-foreground';
          button.setAttribute('aria-label', `Page ${index}`);
          if (index === page) button.setAttribute('aria-current', 'page');
          button.addEventListener('click', () => {
            const url = new URL(window.location.href);
            if (index === 1) url.searchParams.delete('page');
            else url.searchParams.set('page', String(index));
            window.history.replaceState({}, '', url);
            section.scrollIntoView();
            draw();
          });
          pager.appendChild(button);
        }
      } else if (pager) {
        pager.classList.add('hidden');
        pager.classList.remove('flex');
        pager.replaceChildren();
      }
      drawShopGrid(section, pageItems, newHandles, sorted.length);
    };
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.delete('page');
        window.history.replaceState({}, '', url);
        draw();
      });
    }
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-shop-filter-bar]')) return;
      section.querySelectorAll('[data-shop-filter-bar] details').forEach((dropdown) => {
        dropdown.open = false;
      });
    });
    await draw();
  }

  function drawShopGrid(section, products, newHandles, resultCount) {
    const grid = section.querySelector('[data-shop-grid]');
    const empty = section.querySelector('[data-shop-empty]');
    const count = section.querySelector('[data-shop-count]');
    const template = section.querySelector('[data-shop-card-template]');
    grid.innerHTML = '';
    products.forEach((product) => {
      const node = template.content.firstElementChild.cloneNode(true);
      const variant = (product.variants || []).length === 1 ? product.variants[0] : null;
      const price = catalogPrice(product);
      const image = catalogImage(product);
      const url = `${shopRoot()}/products/${product.handle}`;
      node.dataset.handle = product.handle || '';
      node.dataset.brand = product.vendor || '';
      node.dataset.title = product.title || '';
      node.dataset.price = price;
      node.dataset.image = image;
      node.dataset.url = url;
      node.dataset.variantId = variant ? String(variant.id) : '';
      const link = node.querySelector('[data-card-link]');
      link.href = url;
      const photo = node.querySelector('[data-card-image]');
      if (image) {
        photo.src = image;
        photo.alt = `${product.vendor || ''} ${product.title || ''}`.trim();
      } else {
        photo.remove();
      }
      const bag = node.querySelector('[data-card-bag]');
      if (variant) {
        bag.hidden = false;
        if (!variant.available) {
          bag.disabled = true;
          bag.removeAttribute('data-add-to-bag');
          bag.textContent = strings.soldOut || 'Sold Out';
          bag.classList.add('cursor-not-allowed');
        }
      }
      const newBadge = node.querySelector('[data-new-badge]');
      if (newBadge) newBadge.hidden = !newHandles.has(product.handle);
      const saleBadge = node.querySelector('[data-sale-badge]');
      if (saleBadge) saleBadge.hidden = !catalogOnSale(product);
      node.querySelector('[data-card-brand]').textContent = product.vendor || '';
      node.querySelector('[data-card-name]').textContent = product.title || '';
      node.querySelector('[data-card-price]').textContent = price;
      grid.appendChild(node);
    });
    const total = typeof resultCount === 'number' ? resultCount : products.length;
    const hasProducts = total > 0;
    grid.classList.toggle('hidden', !hasProducts);
    grid.classList.toggle('grid', hasProducts);
    if (empty) empty.classList.toggle('hidden', hasProducts);
    if (count) {
      if (total === 1) {
        count.textContent = count.dataset.countOne || '1 result';
      } else {
        count.textContent = (count.dataset.countOther || '2 results').replace('2', String(total));
      }
      count.classList.toggle('hidden', !hasProducts);
    }
    syncFavoriteButtons();
  }

  /* Back is remembered from the click that opened this page. The menu does not count. */
  const backKey = 'euromoda-back';
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('data-back-link')) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.target === '_blank') return;
    let next;
    try {
      next = new URL(link.href, window.location.href);
    } catch (error) {
      return;
    }
    if (next.origin !== window.location.origin) return;
    const here = `${window.location.pathname}${window.location.search}`;
    const to = `${next.pathname}${next.search}`;
    if (!to || to === here) return;
    const section = link.closest('section[id]');
    const from = section && section.id ? `${here}#${section.id}` : here;
    try {
      sessionStorage.setItem(backKey, JSON.stringify({
        from,
        via: link.closest('[data-header]') ? 'nav' : 'page',
        to,
      }));
    } catch (error) {
      /* Storage can be unavailable. The back line simply stays hidden. */
    }
  }, true);

  document.querySelectorAll('[data-back-link]').forEach((link) => {
    let trip = null;
    try {
      trip = JSON.parse(sessionStorage.getItem(backKey) || 'null');
    } catch (error) {
      trip = null;
    }
    const hereUrl = new URL(window.location.href);
    const storedUrl = trip && trip.to ? new URL(trip.to, window.location.origin) : null;
    const samePage = Boolean(storedUrl && storedUrl.pathname === hereUrl.pathname);
    const fromPath = trip && trip.from ? trip.from.split('?')[0].split('#')[0] : '';
    const fromPage = Boolean(trip && trip.via === 'page' && samePage && fromPath && fromPath !== hereUrl.pathname);
    const mtmView = document.querySelector('[data-mtm] [data-mtm-view]:not([hidden])');
    const brandView = Boolean(mtmView && mtmView.dataset.mtmView !== 'home');
    if (!fromPage || brandView) {
      link.parentElement.hidden = true;
      return;
    }
    const sectionBack = document.querySelector('[data-section-back]');
    if (sectionBack) {
      const remembered = new URL(trip.from, window.location.origin);
      const contextual = new URL(sectionBack.getAttribute('href'), window.location.origin);
      if (remembered.pathname === contextual.pathname && remembered.search === contextual.search) {
        link.parentElement.hidden = true;
        return;
      }
    }
    link.href = trip.from;
    link.dataset.backVisible = 'true';
    link.parentElement.hidden = false;
    const label = link.querySelector('[data-back-label]');
    if (label) {
      const journalUrl = link.dataset.journalUrl || '/blogs/news-1';
      const journalPath = new URL(journalUrl, window.location.origin).pathname;
      const fromPath = trip.from.split('?')[0].split('#')[0];
      const fromStory = fromPath.startsWith(`${journalPath}/`) || /\/blogs\/[^/]+\/[^/]+/.test(fromPath);
      label.textContent = fromPath === journalPath
        ? link.dataset.journalLabel
        : fromStory
          ? (link.dataset.storyLabel || link.dataset.backText)
          : link.dataset.backText;
    }
  });

  document.querySelectorAll('[data-sort-select="collection"]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      if (select.value) {
        url.searchParams.set('sort_by', select.value);
      } else {
        url.searchParams.delete('sort_by');
      }
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  document.querySelectorAll('[data-sort-select="url"]').forEach((select) => {
    const currentSort = new URL(window.location.href).searchParams.get('sort_by');
    if (!currentSort || currentSort === 'manual' || currentSort === 'featured') {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', 'best-selling');
      url.searchParams.delete('page');
      window.location.replace(url.toString());
      return;
    }
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      if (select.value) {
        url.searchParams.set('sort_by', select.value);
      } else {
        url.searchParams.delete('sort_by');
      }
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  const shopGroup = document.querySelector('[data-shop-group]');
  if (shopGroup) renderShopGroup(shopGroup);

  /* Brand lists: shop.vendors also counts brands whose products are all unpublished or sold out */
  async function completeVendorList(list) {
    if (list.dataset.vendorListDone) return;
    list.dataset.vendorListDone = 'true';
    let items = [...list.querySelectorAll('[data-vendor]')];
    if (!items.length) return;
    let catalog;
    try {
      catalog = await fetchCatalog();
    } catch (error) {
      return;
    }
    if (list.hasAttribute('data-vendor-in-stock')) {
      catalog = catalog.filter((product) => (product.variants || []).some((variant) => variant.available));
    }
    const published = new Set(catalog.map((product) => (product.vendor || '').toLowerCase()).filter(Boolean));
    const template = items[0];
    const anchor = template.previousElementSibling;
    const blueprint = template.cloneNode(true);
    const keepPast = list.hasAttribute('data-vendor-keep-past');
    items = items.filter((item) => {
      if (published.has(item.dataset.vendor.toLowerCase())) return true;
      if (keepPast) {
        item.removeAttribute('href');
        item.setAttribute('aria-disabled', 'true');
        item.classList.remove('hover:bg-stone-soft', 'hover:opacity-60');
        item.classList.add('cursor-default', 'text-muted-foreground/70');
        return true;
      }
      if (item !== template) item.remove();
      return false;
    });
    const shown = new Set(items.map((item) => item.dataset.vendor.toLowerCase()));
    const missing = [...new Set(catalog.map((product) => product.vendor).filter(Boolean))].filter((vendor) => !shown.has(vendor.toLowerCase()));
    missing.forEach((vendor) => {
      const item = blueprint.cloneNode(true);
      item.dataset.vendor = vendor;
      item.dataset.vendorSort = vendor;
      const url = new URL(item.href, window.location.origin);
      url.searchParams.set('q', vendor);
      item.href = url.pathname + url.search;
      const name = item.matches('[data-vendor-name]') ? item : item.querySelector('[data-vendor-name]');
      if (name) name.textContent = vendor;
      const initial = item.querySelector('[data-vendor-initial]');
      if (initial) initial.textContent = vendor.charAt(0).toUpperCase();
      items.push(item);
    });
    const collator = new Intl.Collator(undefined, { sensitivity: 'base', numeric: true });
    const sortKey = (item) => item.dataset.vendorSort || item.dataset.vendor;
    items.sort((a, b) => collator.compare(sortKey(a), sortKey(b)));
    const limit = Number(list.dataset.vendorList) || items.length;
    template.remove();
    items.forEach((item) => item.remove());
    const fragment = document.createDocumentFragment();
    items.slice(0, limit).forEach((item) => fragment.appendChild(item));
    if (anchor) anchor.after(fragment);
    else list.prepend(fragment);
  }

  document.querySelectorAll('[data-vendor-list]').forEach((list) => {
    if (list.hasAttribute('data-vendor-list-eager')) {
      completeVendorList(list);
      return;
    }
    const details = list.closest('details');
    if (details) details.addEventListener('toggle', () => completeVendorList(list), { once: true });
    const panel = list.closest('[data-menu-panel]');
    const trigger = panel && document.querySelector(`[data-menu-trigger="${panel.dataset.menuPanel}"]`);
    if (trigger) {
      trigger.addEventListener('mouseenter', () => completeVendorList(list), { once: true });
      trigger.addEventListener('focus', () => completeVendorList(list), { once: true });
    }
  });

  function pickDiverseProducts(products, limit) {
    const preferred = [
      't-shirts',
      'shirts',
      'polos',
      'sportcoats & jackets',
      'knitwear',
      'sweatshirts & hoodies',
      'swimwear',
      'pants',
      'shorts',
      'jeans',
      'shoes',
      'accessories',
    ];
    const groups = new Map();
    products.forEach((product) => {
      const type = (product.product_type || '').trim().toLowerCase();
      if (!groups.has(type)) groups.set(type, []);
      groups.get(type).push(product);
    });
    const order = preferred.filter((type) => groups.has(type));
    groups.forEach((_items, type) => {
      if (!order.includes(type)) order.push(type);
    });
    const queues = new Map(order.map((type) => [type, groups.get(type).slice()]));
    const picked = [];
    let added = true;
    while (picked.length < limit && added) {
      added = false;
      order.forEach((type) => {
        if (picked.length >= limit) return;
        const queue = queues.get(type);
        if (!queue || !queue.length) return;
        picked.push(queue.shift());
        added = true;
      });
    }
    return picked;
  }

  function fillDiverseCard(node, product) {
    const variant = (product.variants || []).length === 1 ? product.variants[0] : null;
    const price = catalogPrice(product);
    const image = catalogImage(product);
    const url = `${shopRoot()}/products/${product.handle}`;
    node.dataset.handle = product.handle || '';
    node.dataset.brand = product.vendor || '';
    node.dataset.type = product.product_type || '';
    node.dataset.title = product.title || '';
    node.dataset.price = price;
    node.dataset.image = image;
    node.dataset.url = url;
    node.dataset.variantId = variant ? String(variant.id) : '';
    const link = node.querySelector('[data-card-link]');
    link.href = url;
    const photo = node.querySelector('[data-card-image]');
    if (image) {
      photo.src = image;
      photo.alt = `${product.vendor || ''} ${product.title || ''}`.trim();
    } else if (photo) {
      photo.remove();
    }
    const brand = node.querySelector('[data-card-brand]');
    if (brand) brand.textContent = product.vendor || '';
    const name = node.querySelector('[data-card-name]');
    if (name) name.textContent = product.title || '';
    const priceNode = node.querySelector('[data-card-price]');
    if (priceNode) priceNode.textContent = price;
    const sale = node.querySelector('[data-sale-badge]');
    if (sale) sale.hidden = !catalogOnSale(product);
    const bag = node.querySelector('[data-card-bag]');
    if (bag && variant) {
      bag.hidden = false;
      if (!variant.available) {
        bag.disabled = true;
        bag.removeAttribute('data-add-to-bag');
        bag.textContent = strings.soldOut || 'Sold Out';
        bag.classList.add('cursor-not-allowed', 'text-muted-foreground');
      }
    }
  }

  async function renderDiverseNew(section) {
    const grid = section.querySelector('[data-diverse-grid]');
    const template = section.querySelector('[data-diverse-card]');
    const handle = section.dataset.collection;
    if (!grid || !template || !handle) return;
    const limit = Number(section.dataset.limit) || 8;
    let products;
    try {
      products = await loadCatalog(handle);
    } catch (error) {
      return;
    }
    const picked = pickDiverseProducts(products, limit);
    if (!picked.length) return;
    grid.replaceChildren();
    picked.forEach((product) => {
      const node = template.content.firstElementChild.cloneNode(true);
      fillDiverseCard(node, product);
      grid.appendChild(node);
    });
    syncFavoriteButtons();
  }

  document.querySelectorAll('[data-diverse-new]').forEach((section) => {
    renderDiverseNew(section);
  });

  function railProductTitle(product) {
    const vendor = product.vendor || '';
    const title = product.title || '';
    if (vendor && title.slice(0, vendor.length) === vendor) return title.slice(vendor.length).trim();
    return title;
  }

  async function renderProductRail(section) {
    const track = section.querySelector('[data-rail-track]');
    const template = section.querySelector('[data-rail-card]');
    if (!track || !template) return;
    const limit = Number(section.dataset.railLimit) || 12;
    let products;
    try {
      products = await sortShopProducts(await fetchCatalog(section.dataset.railSource || 'all'), 'best-selling');
    } catch (error) {
      return;
    }
    track.replaceChildren();
    products.slice(0, limit).forEach((product) => {
      const node = template.content.firstElementChild.cloneNode(true);
      const card = node.querySelector('[data-product-card]') || node;
      fillDiverseCard(card, { ...product, title: railProductTitle(product) });
      track.appendChild(node);
    });
    syncFavoriteButtons();
  }

  function setupProductRail(section) {
    if (section.dataset.railLayout === 'grid') return;
    const track = section.querySelector('[data-rail-track]');
    const meter = section.querySelector('[data-rail-meter]');
    const fill = section.querySelector('[data-rail-meter-fill]');
    const next = section.querySelector('[data-rail-next]');
    const prev = section.querySelector('[data-rail-prev]');
    if (!track || !meter || !fill || !next || !prev) return;

    const distance = () => {
      const card = track.querySelector('.product-rail__card');
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      if (!card) return Math.max(track.clientWidth * 0.7, 240);
      return card.getBoundingClientRect().width + gap;
    };
    const update = () => {
      const total = track.scrollWidth || 1;
      const seen = Math.min(total, track.scrollLeft + track.clientWidth);
      fill.style.width = `${(seen / total) * 100}%`;
    };
    const go = (direction) => {
      const max = track.scrollWidth - track.clientWidth;
      let left = track.scrollLeft + distance() * direction;
      if (direction > 0 && left > max - 8) left = 0;
      if (direction < 0 && track.scrollLeft < 8) left = max;
      track.scrollTo({ left, behavior: 'smooth' });
    };

    next.addEventListener('click', () => go(1));
    prev.addEventListener('click', () => go(-1));
    meter.addEventListener('click', (event) => {
      const rect = meter.getBoundingClientRect();
      const ratio = rect.width ? (event.clientX - rect.left) / rect.width : 0;
      const max = track.scrollWidth - track.clientWidth;
      track.scrollTo({ left: ratio * max, behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    let paused = false;
    let resumeTimer;
    const hold = () => {
      paused = true;
      clearTimeout(resumeTimer);
    };
    const release = () => {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => { paused = false; }, 7000);
    };
    section.addEventListener('mouseenter', hold);
    section.addEventListener('mouseleave', release);
    section.addEventListener('focusin', hold);
    section.addEventListener('focusout', release);
    track.addEventListener('pointerdown', hold);
    track.addEventListener('pointerup', release);
    window.setInterval(() => {
      if (!paused && !document.hidden) go(1);
    }, 4800);
  }

  document.querySelectorAll('[data-product-rail]').forEach((section) => {
    const start = () => setupProductRail(section);
    if (section.dataset.railSort === 'best-selling') {
      renderProductRail(section).then(start);
    } else {
      start();
    }
  });

  renderCart();
  refreshCart();
})();
